import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import PropTypes from 'prop-types';
import Icon from 'apps/new-web/views/components/icon';
import I18n from 'apps/new-web/views/components/i18n';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { blueGray80 } from 'apps/new-web/views/themes/colors';
import CHEVRON_DOWN_LINE from '@ifit/react-icons/dist/icons/CHEVRON_DOWN_LINE';
import CHEVRON_UP_LINE from '@ifit/react-icons/dist/icons/CHEVRON_UP_LINE';

class ProfileLinks extends BaseComponent {
  toggleSettings() {
    this.setState(prevState => ({ settingsOpen: !prevState.settingsOpen }));
  }

  settingsClose() {
    this.setState({ settingsOpen: false });
  }

  render() {
    return (
      <nav className="profile-links-component">
        <div className="profile-toggle" onClick={ this.toggleSettings }>
          <p>{ this.props.fullname }</p>
          <Icon
            className="dropdown-icon"
            icon={ this.state.settingsOpen ? CHEVRON_DOWN_LINE : CHEVRON_UP_LINE }
            size={ 20 }
            color={ blueGray80 }
          />
          { this.state.settingsOpen &&
            <ClickAwayListener onClickAway={ this.settingsClose }>
              <div className="settings-popup">
                <a href="/settings"><I18n>Settings</I18n></a>
                <a href="/settings"><I18n>Profile</I18n></a>
                <a href="/logout"><I18n>Log out</I18n></a>
              </div>
            </ClickAwayListener>
          }
        </div>
      </nav>
    );
  }
}

ProfileLinks.propTypes = {
  fullname: PropTypes.string
};

export default ProfileLinks;
